<template>
  <Modal title="喫食情報" :loading="busy" @close="close" size="middle">
    <div class="customer-eat">
      <div class="eat-header-info">
        <dl class="eat-time">
          <dt>
            <ClockIcon width="16" height="16" />
            来店時間
          </dt>
          <dd>{{ orders.visitTime }}</dd>
          <dt>
            <ClockIcon width="16" height="16" />
            退店時間
          </dt>
          <dd>{{ orders.payTime }}</dd>
        </dl>
        <dl class="eat-info">
          <dt class="eat-people"><AddPeopleIcon width="16" height="16" />人数</dt>
          <dd>{{ orders.persons }}</dd>
          <dt>お支払金額</dt>
          <dd>¥{{ orders.payment }}</dd>
        </dl>
      </div>
      <dl class="eat-order-list" v-for="(item, index) in orders.menu" :key="index">
        <dt class="order-name">{{ item.name }}</dt>
        <dd class="order-price">¥{{ item.price }}</dd>
        <dd class="order-qty">{{ item.qty }}</dd>
      </dl>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import ClockIcon from '@/components/icons/clock'
import AddPeopleIcon from '@/components/icons/addPeople'
import Modal from '@/components/molecules/Modal'

/**
 * 喫食情報モーダル
 */
export default {
  name: 'EatInfoModal',
  components: {
    ClockIcon,
    AddPeopleIcon,
    Modal,
  },
  props: {
    reserveId: Number,
  },
  computed: {
    ...mapState({
      orders: state => state.orders.detail,
      busy: state => state.orders.busy,
    }),
  },
  mounted() {
    this.$store.dispatch('orders/get', this.reserveId)
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.customer-eat {
  .eat-header-info {
    border-bottom: 1px solid var(--border-color);
    box-sizing: border-box;
    display: flex;
    margin-bottom: 24px;
    padding: 0 0 24px 18px;

    dl {
      align-items: center;
      display: grid;
      grid-gap: 8px 16px;
    }

    .eat-time dt,
    .eat-people {
      align-items: center;
      display: grid;
      grid-auto-flow: column;
      grid-gap: 0 8px;
      grid-template-columns: 16px 1fr;
    }

    .eat-time {
      grid-template: 24px / 88px 1fr;
    }

    .eat-info {
      grid-template: 24px / 80px 1fr;
      margin-left: 32px;

      .eat-people {
        grid-column: 1/2;
      }
    }

    svg {
      fill: var(--very-dark-gray-2);
    }
  }

  .eat-order-list {
    display: grid;
    grid-gap: 0 16px;
    grid-template-columns: 1fr max-content 40px;
    margin: 0 16px;

    &.hide-price {
      grid-template-columns: 1fr 40px;
    }

    & + .eat-order-list {
      margin-top: 8px;
    }
  }

  .order-price,
  .order-qty {
    justify-self: flex-end;
  }

  .responsive & {
    @media screen and (--sp-modal) {
      height: 100%;

      .eat-header-info {
        display: block;
        padding-bottom: 24px;
        padding-left: 0;
      }

      .eat-info,
      .eat-time {
        grid-gap: 8px 0;

        dd {
          justify-self: end;
        }
      }

      .eat-info {
        margin-left: 0;
        margin-top: 8px;

        .eat-people {
          display: grid;
          grid-auto-flow: column;
          grid-column: 1/2;
          grid-gap: 0 8px;
          grid-template-columns: 16px 1fr;
        }
      }

      .eat-order-list {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
}
</style>
